import React from "react";
import {StockInformationModel} from "../domain/stockInformationModel";

type InStockModelType = Pick<
    StockInformationModel,
    | "leadIn"
    | "isInternalProduct"
    | "quantityOnHand"
    | "minimumQuantity"
    | "shipsSameDay"
    | "shipCutoffDate"
    | "canShipToday"
    | "shipEstimatedDate"
>;

export class InStockModel {
    private _model: InStockModelType;

    constructor(model: InStockModelType) {
        this._model = model;
    }

    get showInStock() {
        return this._model.leadIn < 5;
    }

    get showLowStockWarning() {
        return (
            this._model.isInternalProduct &&
            this._model.quantityOnHand <= this._model.minimumQuantity * 5
        );
    }

    get lowStockWarningMessage() {
        return (
            <>
                Order soon! Only <strong>{this._model.quantityOnHand}</strong> unit
                {this._model.quantityOnHand > 1 ? "s" : ""} left.{" "}
            </>
        );
    }

    get leadIn() {
        return this._model.leadIn;
    }

    get canShipToday() {
        return this._model.canShipToday;
    }

    get shipEstimatedDate() {
        return this._model.shipEstimatedDate;
    }

    get shipsSameDay() {
        return this._model.shipsSameDay;
    }

    get shipCutoffDate() {
        return this._model.shipCutoffDate;
    }

    get showShipsInMessage() {
        return this._model.leadIn > 0
    }

    public get formatted() {
        return {
            shipEstimatedDateUtc: new Date(this._model.shipEstimatedDate).toLocaleDateString("en-US", {
                timeZone: "UTC",
                weekday: "long",
                month: "short",
                day: "numeric",
            })
        }
    }

    static create(model: StockInformationModel) {
        return new InStockModel(model);
    }
}
